
function SafeImage ({ src, altSources }){
//  const imgRef = useRef();
//TODO: make itlike SafeAudio

  const onImageError = (e) => {
    let currentSrc = ""
    if(altSources.length > 0){
        currentSrc = altSources.shift()
    }
    e.currentTarget.src = currentSrc
}


  return (
    <img 
    src={src} 
    onError={(e) => (onImageError(e))}
    />
  )
}



export default SafeImage